import { RouteObject } from 'react-router-dom';
import { DASHBOARD_BASE_PATH } from '../home/data/useHomeBasePath';
import { createHomePageRoutes } from '../home/HomeRoutes';

export const dashboardRoutes: RouteObject[] =
  createHomePageRoutes(DASHBOARD_BASE_PATH);
